import { Button, Card, Form, Input } from "antd";
import { Toast } from "primereact/toast"; // Add PrimeReact Toast import
import { LockOutlined, MailOutlined } from "@ant-design/icons";
import HTTPService from "../../../utils/makerequest";
import { IPageProps } from "../../../interfaces/page-data";
import { StateLoader } from "../../../redux/StateLoader";
import { IAuthentication } from "../../../interfaces/authentication";
import { t } from "i18next";
import { useRef } from "react"; // Add useRef import

const EmailChange: React.FunctionComponent<IPageProps> = () => {
    const loader = new StateLoader();
    const authInfo: IAuthentication = loader.loadAuthState();
    const toast = useRef<any>(null); // Add toast ref

    const update = (e) => {
        HTTPService.PUT(`/User/UpdateEmail?email=${authInfo.email}&newEmail=${e.newEmail}&password=${e.Password}`, {})
            .then((res) => {
                if (res.status === 200) {
                    toast.current?.show({
                        severity: 'success',
                        summary: t('successful'),
                        detail: t(res.data),
                        life: 3000
                    });
                } else if (res.status === 450) {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: t(res.data),
                        life: 3000
                    });
                } else if (res.status === 400) {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: t(res.data),
                        life: 3000
                    });
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: t(res.data),
                        life: 3000
                    });
                }
            })
            .catch(error => {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t('error_message'),
                    life: 3000
                });
                console.error('Email update error:', error);
            });
    }

    return (
        <Card style={{ padding: '50px' }}>
            <Toast ref={toast} /> {/* Add Toast component */}
            <h3>{t('Change Email')}</h3>
            <Form
                layout='vertical'
                onFinish={update}
            >
                <Form.Item name='newEmail'
                    label={t('email')}
                    rules={[
                        {
                            required: true,
                            message: t('please_input_email'),
                            whitespace: true,
                        },
                        {
                            pattern: /^[^\s]+$/,
                            message: t('emailNotSpaces'),
                        },
                    ]}
                >
                    <Input
                        prefix={<MailOutlined />}
                        placeholder={t('email')}
                        style={{ borderRadius: 0 }}
                    />
                </Form.Item>
                <Form.Item name='Password'
                    label={t('password')}
                    rules={[{ required: true, message: t('please_input_your_password') }]}
                >
                    <Input.Password
                        prefix={<LockOutlined />}
                        placeholder={t('password')}
                        style={{ borderRadius: 0 }}
                    />
                </Form.Item>
                <Form.Item>
                    <div className='span d-flex justify-content-between'>
                        <span />
                        <Button htmlType="submit" type="primary" style={{ borderRadius: 0 }}>
                            {t('save')}
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        </Card>
    );
}
export default EmailChange;